<div class="flex flex-column h-full pb-4">
  <form [formGroup]="formGroup" class="flex flex-column gap-4 mb-4">
    <div class="flex flex-column gap-2">
      <label for="institution" class="font-medium">Institution</label>
      <p-select id="institution" aria-describedby="institution-help" formControlName="institutionId" optionValue="id"
                  [editable]="true" filter="true" filterBy="name" [options]="institutions"
                  optionLabel="name" placeholder="Sélectionner une institution"/>
      <small id="institution-help">Renseigner ici le nom de l'institution.</small>
    </div>

    <div class="flex flex-column gap-2">
      <label for="name" class="font-medium">Nom de la caisse *</label>
      <input pInputText id="name" aria-describedby="name-help" formControlName="name" />
      <small id="name-help">Renseigner ici le nom de la caisse (ex: Caisse Principale).</small>
    </div>

    <div class="flex flex-column gap-2">
      <label for="code" class="font-medium">Code *</label>
      <input pInputText id="code" aria-describedby="code-help" formControlName="code" />
      <small id="code-help">Renseigner ici le code unique de la caisse (ex: CA-001).</small>
    </div>

    <div class="flex flex-column gap-2">
      <label for="type" class="font-medium">Type de caisse *</label>
      <p-select id="type" aria-describedby="type-help" formControlName="type"
                  [options]="cashRegisterTypes"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Sélectionner le type de caisse"/>
      <small id="type-help">Sélectionner le type de caisse.</small>
    </div>

    <div class="flex flex-column gap-2">
      <label for="mainCurrency" class="font-medium">Devise principale *</label>
      <p-select id="mainCurrency" aria-describedby="mainCurrency-help" formControlName="mainCurrency"
                  [editable]="true" filter="true"
                  filterBy="code,description" [options]="currencies" optionLabel="description"
                  optionValue="code" placeholder="Sélectionner une devise" />
      <small id="mainCurrency-help">Sélectionner la devise principale de la caisse.</small>
    </div>

    <div class="flex flex-column gap-2">
      <label for="minBalance" class="font-medium">Solde Minimum</label>
      <p-inputNumber id="minBalance" formControlName="minBalance" mode="decimal" [minFractionDigits]="2"
                     placeholder="Solde minimum" />
      <small id="minBalance-help">Seuil minimum de solde (optionnel).</small>
    </div>

    <div class="flex flex-column gap-2">
      <label for="maxBalance" class="font-medium">Solde Maximum</label>
      <p-inputNumber id="maxBalance" formControlName="maxBalance" mode="decimal" [minFractionDigits]="2"
                     placeholder="Solde maximum" />
      <small id="maxBalance-help">Seuil maximum de solde (optionnel).</small>
    </div>

    <div class="flex flex-column gap-2 mb-4">
      <label for="linkedAccount" class="font-medium">Compte lié</label>
      <p-select id="linkedAccount" aria-describedby="linkedAccount-help" formControlName="linkedAccountId"
                  [editable]="true" filter="true" filterBy="libelle,number" [options]="accounts"
                  optionValue="id" optionLabel="libelle" placeholder="Sélectionner un compte (optionnel)" />
      <small id="linkedAccount-help">Compte comptable lié à cette caisse (optionnel).</small>
    </div>
  </form>

  <div class="flex mb-4 gap-2 justify-content-end">
    <p-button pRipple *ngIf="!formGroup.disabled" [style]="{width: '100%'}" class="mb-4"
              [label]="boundData?.isCreate ? 'Enregistrer' : 'Modifier'"
              [disabled]="!formGroup.valid"
              [loading]="isLoading"
              (onClick)="onSubmit()">
    </p-button>
  </div>
</div>
